import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email({
    message: "有効なメールアドレスを入力してください",
  }),
  password: z.string().min(1, {
    message: "パスワードは必須です。",
  }),
});

export const magicLinkRequestSchema = z.object({
  email: z.string().email({
    message: "有効なメールアドレスを入力してください",
  }),
});

export default loginSchema;
